import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table } from 'reactstrap';
import { array } from 'prop-types';
import PaymentDataListItem from './PaymentDataListItem';

const propTypes = {
  operations: array.isRequired,
};

const defaultProps = {
  operations: [],
};

const PaymentDataList = ({ operations }) => (
  <Table className="payments-table" responsive bordered>
    <thead className="thead-light">
      <tr>
        <th>
          <FormattedMessage id="payments.table.date" defaultMessage="Date" />
        </th>
        <th className='text-right'>
          <FormattedMessage id="payments.table.hold" defaultMessage="Hold" />
        </th>
        <th className='text-right'>
          <FormattedMessage id="payments.table.balance" defaultMessage="Balance" />
        </th>
        <th>
          <FormattedMessage id="payments.table.currency" defaultMessage="Currency" />
        </th>
        <th>
          <FormattedMessage id="payments.table.comment" defaultMessage="Comment" />
        </th>
      </tr>
    </thead>
    <tbody>
      {operations.length > 0 &&
        operations.map((operation, index) => (
          <PaymentDataListItem key={`PaymentItem_${index}`} {...operation} />
        ))}
    </tbody>
  </Table>
);

PaymentDataList.propTypes = propTypes;
PaymentDataList.defaultProps = defaultProps;

export default PaymentDataList;
